import Http from '../index.js'
import Model from '../Model.js'

class DigitalAccounts extends Model {
  constructor() {
    super('/digital_accounts/')
  }

  getHistory(id, query = '') {
    return Http.get(`${this.model}${id}/historic/${query}`)
  }

  generateOfx(startDate, endDate, accountId, email) {
    return Http.post(`${this.model}generate_ofx/`, {
      start_date: startDate,
      end_date: endDate,
      digital_account: accountId,
      email,
    })
  }

  statement(payload, query = '') {
    return Http.post(`${this.model}statement/${query}`, payload)
  }

  statementSummary(payload, query = '') {
    return Http.post(`${this.model}statement_summary/${query}`, payload)
  }
}

export default new DigitalAccounts()
